module.exports = __webpack_public_path__ + "img/cookislands.e50fc502.svg";